// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 13001-订单概览 按日汇总订单量与销售额（按支付时间） POST /web/v1/reconcile/order/overview */
export async function orderOverview(
  body: any,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOOrderOverviewResp>(
    "/web/v1/reconcile/order/overview",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 13002-渠道概览 按日汇总支付渠道（按支付时间） POST /web/v1/reconcile/pay/channel */
export async function payChannelOverview(
  body: any,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOPayChannelResp>(
    "/web/v1/reconcile/pay/channel",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 13005-支付记录导出 按支付时间范围导出支付记录（CSV/Excel） POST /web/v1/reconcile/pay/export */
export async function exportPayRecord(
  body: any,
  options?: { [key: string]: any }
) {
  return request<string>("/web/v1/reconcile/pay/export", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 13003-商品类型金额概览 按日按商品类型汇总（按支付时间） POST /web/v1/reconcile/pay/goodsType */
export async function payAmountByGoodsType(
  body: any,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOPayAmountByGoodsTypeResp>(
    "/web/v1/reconcile/pay/goodsType",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 13004-支付记录列表 按支付时间范围查询支付记录（分页） POST /web/v1/reconcile/pay/list */
export async function payRecordList(
  body: any,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOPayRecordItemRespVo>(
    "/web/v1/reconcile/pay/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 13004-支付记录列表 按支付时间范围查询支付记录（分页） POST /web/v1/reconcile/pay/list */
export async function exportPayRecordList(
  body: any,
  options?: { [key: string]: any }
) {
  return request<Blob>("/web/v1/reconcile/pay/export", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
    data: body,
    ...(options || {}),
  });
}
